import React, { useState } from "react";
import clockIcon from "../../assets/images/clock.svg";
import "./Title.css";
const Tooltip = ({ id, text, children }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="tooltip-container">
      <div
        // className="tooltip-trigger"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>
      {visible &&
        (id === 0 ?
          <div className="tooltip-box-settings">
                <img src={clockIcon} alt="" />
                <span>{"This feature is coming soon"}</span>
              </div>
              : (
          <>
            {id > 0 && text ? (
              <div className="second-title">{text}</div>
            ) : (
              <div className="tooltip-box">
                <img src={clockIcon} alt="" />
                <span>{"This feature is coming soon"}</span>
              </div>
            )}
          </>
        ))}
    </div>
  );
};
export default Tooltip;
